import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomerZoneChanges from "./CustomerZoneChanges";
import CustomerZoneModelChange from "./CustomerZoneModelChange";
import { Breakpoint } from "react-socks";

export default function CustomerTimelineZone() {
  const [activeTab, setActiveTab] = useState("CustomerZoneChanges");
  const [hoveredTab, setHoveredTab] = useState(null);
  const { t } = useTranslation();

  const baseTabStyle = {
    padding: "10px 20px",
    margin: "0 5px",
    borderRadius: "8px 8px 0 0",
    border: "1px solid var(--theme-border-soft)",
    cursor: "pointer",
    background: "var(--theme-bg-surface)",
    color: "var(--theme-text-secondary)",
    fontWeight: "normal",
    transition: "all 160ms ease",
  };

  const getTabStyle = (tabName) => {
    const isActive = activeTab === tabName;
    const isHovered = hoveredTab === tabName;

    return {
      ...baseTabStyle,
      borderBottom: isActive
        ? "2px solid var(--theme-color-primary)"
        : isHovered
          ? "1px solid var(--theme-color-primary-hover)"
          : "1px solid var(--theme-border-soft)",
      background: isActive || isHovered ? "var(--theme-bg-elevated)" : baseTabStyle.background,
      color: isActive || isHovered ? "var(--theme-text-primary)" : baseTabStyle.color,
      fontWeight: isActive ? "bold" : baseTabStyle.fontWeight,
    };
  };

  return (
    <div style={{ padding: "20px" }}>
      <Breakpoint medium up>
        <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "20px" }}>
          <button
            onClick={() => setActiveTab("CustomerZoneChanges")}
            onMouseEnter={() => setHoveredTab("CustomerZoneChanges")}
            onMouseLeave={() => setHoveredTab(null)}
            style={getTabStyle("CustomerZoneChanges")}
          >
            {t("CustomerZoneChanges")}
          </button>
          <button
            onClick={() => setActiveTab("CustomerZoneModelChange")}
            onMouseEnter={() => setHoveredTab("CustomerZoneModelChange")}
            onMouseLeave={() => setHoveredTab(null)}
            style={getTabStyle("CustomerZoneModelChange")}
          >
            {t("CustomerZoneModelChange")}
          </button>
        </div>
      </Breakpoint>

      <Breakpoint small down>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "20px" }}>
          <button
            onClick={() => setActiveTab("CustomerZoneChanges")}
            onMouseEnter={() => setHoveredTab("CustomerZoneChanges")}
            onMouseLeave={() => setHoveredTab(null)}
            style={{ ...getTabStyle("CustomerZoneChanges"), fontSize: "14px", padding: "8px 12px", margin: 0 }}
          >
            {t("CustomerZoneChanges")}
          </button>
          <button
            onClick={() => setActiveTab("CustomerZoneModelChange")}
            onMouseEnter={() => setHoveredTab("CustomerZoneModelChange")}
            onMouseLeave={() => setHoveredTab(null)}
            style={{ ...getTabStyle("CustomerZoneModelChange"), fontSize: "14px", padding: "8px 12px", margin: 0 }}
          >
            {t("CustomerZoneModelChange")}
          </button>
        </div>
      </Breakpoint>

      <div>
        {activeTab === "CustomerZoneChanges" && <CustomerZoneChanges />}
        {activeTab === "CustomerZoneModelChange" && <CustomerZoneModelChange />}
      </div>
    </div>
  );
}
